import { render } from "./CardCarritoComponent.vue?vue&type=template&id=93563dd0&scoped=true"
import script from "./CardCarritoComponent.vue?vue&type=script&lang=js"
export * from "./CardCarritoComponent.vue?vue&type=script&lang=js"

import "./CardCarritoComponent.vue?vue&type=style&index=0&id=93563dd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93563dd0"]])

export default __exports__